/*
 * View for the status selector for response templates
 */

define(["marionette", "./template/responseTemplateStatusTemplate.html"], function (
  Marionette,
  ResponseTemplateStatusTemplate,
) {
  var ResponseTemplateStatusView = {};

  ResponseTemplateStatusView.responseTemplateStatusView = Marionette.ItemView.extend({
    template: ResponseTemplateStatusTemplate,
    tagName: "span",
    modelEvents: {
      sync: "render",
      change: "render",
    },
  });

  return ResponseTemplateStatusView;
});
